import React from "react";

interface KPICardProps {
  data: {
    label: string;
    value: string;
    change: string;
    trend: "up" | "down";
    changeType: "positive" | "negative" | "neutral";
    comparison: string;
    subtext?: string;
    breakdown?: {
      expVariance: number;
      revVariance: number;
      expLabel: string;
      revLabel: string;
    };
  };
}

const TrendUp = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M2 7L5 3.5L8 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const TrendDown = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M2 3L5 6.5L8 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const fmtVar = (v: number) => `${v >= 0 ? "+" : ""}$${(Math.abs(v) / 1_000_000).toFixed(1)}M`;

const KPICard: React.FC<KPICardProps> = ({ data }) => {
  const { breakdown } = data;
  return (
    <div className="kpi-card">
      <div className="kpi-header-row">
        <span className="kpi-label">{data.label}</span>
        <span className={`kpi-badge kpi-badge--${data.changeType}`}>
          {data.trend === "up" ? <TrendUp /> : <TrendDown />}
          {data.change}
        </span>
      </div>
      <div className="kpi-value">{data.value}</div>
      {breakdown ? (
        <div className="kpi-breakdown">
          <div className={`kpi-breakdown-line ${breakdown.expVariance >= 0 ? "kpi-breakdown-line--positive" : "kpi-breakdown-line--negative"}`}>
            <span className="kpi-breakdown-tag">EXP</span>
            <span className="kpi-breakdown-amount">{breakdown.expLabel}</span>
            <span className="kpi-breakdown-var">{fmtVar(breakdown.expVariance)}</span>
          </div>
          <div className={`kpi-breakdown-line ${breakdown.revVariance >= 0 ? "kpi-breakdown-line--positive" : "kpi-breakdown-line--negative"}`}>
            <span className="kpi-breakdown-tag">REV</span>
            <span className="kpi-breakdown-amount">{breakdown.revLabel}</span>
            <span className="kpi-breakdown-var">{fmtVar(breakdown.revVariance)}</span>
          </div>
        </div>
      ) : (
        <div className="kpi-comparison">{data.comparison}</div>
      )}
    </div>
  );
};

export default KPICard;
